<!--
  ~ Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='full-page p-5'>
  <div class='content'>
    <div class='title'><h1>{{ 'shell-app.companyValidation.title' | translate }}</h1></div>
    <div class='body mt-lg py'>
      <well-legal-entity-inputs #legalEntityForm
                                [showEmailImportSettings]='true'
                                [legalEntity]='companyDetailsDtoModel?.legalEntityDTO'
                                (save)='onValidateCompanyDetails($event)' data-testid="legal-entity-inputs-input">
      </well-legal-entity-inputs>
    </div>

  </div>

  <div class='footer py text-align-center'>
    <div class='row'>
      <div class='col-12'>
        <button pButton type='button'
                [label]="'shell-app.companyValidation.validateCompanyDetails' | translate"
                (click)='legalEntityForm.onSubmit()' data-testid="legal-entity-form-on-submit-btn">
        </button>
      </div>
    </div>
  </div>
</div>


